import React from 'react'
import { toCurrencyFormat } from '@jagad/utils'
import { JIDRCurrency } from '../CurrencyIcon/CurrencyIcon'
import {
  Container,
  Label,
  AmountContainer,
  Amount,
  InsufficientText,
  InsufficientAmount,
  TopUpButtonContainer,
  TopUpButtonText,
  ActionTopUpIcon
} from './PaymentSummaryAmount.styles'

type TopUpButtonProps = {
  label: string
  onPress?: () => void
}

const TopUpButton = ({ label, onPress }: TopUpButtonProps) => {
  return (
    <TopUpButtonContainer onClick={onPress}>
      <TopUpButtonText>
        {label}
      </TopUpButtonText>
      <ActionTopUpIcon />
    </TopUpButtonContainer>
  )
}

export type PaymentSummaryAmountProps = {
  amount: number
  currentBalance?: number
  onTopUpPress?: () => void
  /** Translated label for the total amount heading */
  labelText: string
  /** Translated prefix for the insufficient balance message (e.g. "You need") */
  insufficientBalancePrefix: string
  /** Translated suffix for the insufficient balance message (e.g. "more JIDR") */
  insufficientBalanceSuffix: string
  /** Translated label for the top-up button */
  topUpLabel: string
}

export function PaymentSummaryAmount({
  amount,
  currentBalance,
  onTopUpPress,
  labelText,
  insufficientBalancePrefix,
  insufficientBalanceSuffix,
  topUpLabel,
}: PaymentSummaryAmountProps) {
  const isInsufficientBalance = currentBalance !== undefined && currentBalance < amount
  const shortfall = isInsufficientBalance ? amount - currentBalance : 0

  return (
    <Container>
      <Label>
        {labelText}
      </Label>
      <AmountContainer>
        <JIDRCurrency />
        <Amount>{toCurrencyFormat(amount)}</Amount>
      </AmountContainer>
      {isInsufficientBalance && (
        <>
          <InsufficientText>
            {insufficientBalancePrefix}
            <InsufficientAmount>
              {` ${toCurrencyFormat(shortfall)} JIDR`}
            </InsufficientAmount>
            {` ${insufficientBalanceSuffix}`}
          </InsufficientText>
          <TopUpButton label={topUpLabel} onPress={onTopUpPress} />
        </>
      )}
    </Container>
  )
}

export default PaymentSummaryAmount
